import { globalAPIDictionary } from "@core/global/global-country-dictionary";
import { createAsyncThunk } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/browser";
import axios from "axios";

export const getSidebarCountData = createAsyncThunk("data/setSidebarCount", async () => {
  try {
    const { data } = await axios.get(globalAPIDictionary.getSidebarCount);
    return data;
  } catch (error) {
    Sentry.captureException(error);
  }
});
